import React, {Component} from 'react'
import { Data } from '../../_core/models'
import { DataRouter } from '../../_core/controllers'

import Layout from '../../templates/_layout';

class Router extends Component {

  constructor() {
    super()

  }

  

  render () {
      return (
      <DataRouter routes={[
          
          // Reset image on all routes
          {
            route:'(.*)/?',
            data : (matches,data)=> {
              
              return {SHOWMISREP:false,SHOWDOWNLOADS:false,SHOWIMAGE:false}

            }
          },
          // Set an IMAGE variable based on a hash value
          // eg /about/#/image/1/
          {
            route:'#/image/(.*)/?',
            data : (matches,data)=> {
              
              return {IMAGE:parseInt(matches[1]),SHOWIMAGE:true}

            }
          },
          {
            route:'#/misrep/(.*)/?',
            data : (matches,data)=> {
              
              return {SHOWMISREP:true}

            }
          },
          {
            route:'#/download/(.*)/?',
            data : (matches,data)=> {
              
              return {SHOWDOWNLOADS:true}

            }
          },
          ]}>
          <Data>
              {()=>(

                  <Layout />
              )}
          </Data>
      </DataRouter>
      )
  }
}

export default Router



// WEBPACK FOOTER //
// ./src/js/components/Router/Router.jsx